import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
const ModalToCheckProductForApproval = ({
  handdleApproveProduct,
  productModalShowApproval,
  setProductModalShowApproval,
  data,
  modalLoading,
  setModalApproveBtn,
}) => {
  const onHide = () => {
    //setModalApproveBtn(false);
    setProductModalShowApproval(false);
  };

  const readableFields = {
    percent_down_payment: '% Down Payment',
    percent_intransit: '% In Transit',
    percent_upon_delivery: '% Upon Delivery',
    vat_exemption: 'Vat Exemption',
    cost: 'Cost Per Box',
    cost_vat: 'Cost Per Box (Vat Ex)',
    cost_unit: 'Cost Per Unit',
    cost_unit_vat: 'Cost Per Unit (Vat Ex)',
    selling_price: 'Selling Price Per Box',
    selling_price_vat: 'Selling Price Per Box (Vat Ex)',
    selling_price_unit: 'Selling Price Per Unit',
    selling_price_unit_vat: 'Selling Price Per Unit (Vat Ex)',
    percent_amount: 'Percent Amount',
    days_remaining: 'Days Remaining',
  };

  // Helper function to get dynamic label
  function getFieldLabel(fieldName) {
    // Check if it's a payments field like payments[0][percent_amount]
    const paymentsRegex = /^payments\[\d+\]\[(\w+)\]$/;
    const match = fieldName.match(paymentsRegex);

    if (match) {
      const field = match[1];
      if (field === 'percent_amount') return 'Percent Amount After Delivery';
      if (field === 'days_remaining') return 'Days Remaining After Delivery';
      return field.replace(/_/g, ' '); // fallback
    }

    // Static field lookup
    return readableFields[fieldName] || fieldName.replace(/_/g, ' ');
  }

  return (
    <Modal
      show={productModalShowApproval}
      onHide={onHide}
      keyboard={false}
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          Product field(s) Changes
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label column sm="4">
            <b style={{ textTransform: 'capitalize' }}>
              PRODUCT NAME
              <span className="text-danger">*</span>
            </b>
          </Form.Label>
          <Col sm="8">
            <Form.Control
              rows={3}
              className="position-relative"
              value={data?.product_name}
              readOnly
            />
          </Col>
        </Form.Group>
        <Container>
          <table className="table table-bordered">
            <tr>
              <th>FIELD NAME</th>
              <th>FROM</th>
              <th>TO</th>
            </tr>
            {data?.changes?.text.map((rows, idx) => (
              <tr>
                <td style={{ textTransform: 'capitalize', fontWeight: 'bold' }}>
                  {getFieldLabel(rows?.field_name)}
                </td>
                <td>{rows?.old_value}</td>
                <td>{rows?.new_value}</td>
              </tr>
            ))}
          </table>
        </Container>
      </Modal.Body>
      {modalLoading && (
        <Backdrop
          sx={(theme) => ({
            color: '#fff',
            zIndex: theme.zIndex.drawer + 1,
          })}
          open={modalLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Modal.Footer className="d-flex justify-content-between align-items-center w-100">
        <div className="flex-grow-1 text-center">
          <h4>Are you sure you want to approve this request?</h4>
          <Button variant="danger" onClick={onHide}>
            Close
          </Button>
          &nbsp;
          <Button variant="success" onClick={handdleApproveProduct}>
            Approve
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalToCheckProductForApproval;
